import React__default from 'react';
import BottomSheet from './BottomSheet.js';
import { L as Label, a as LabelTypography, b as LabelColors } from '../chunks/bundle-DDzCV2KR.js';
import { u as useLocalization } from '../chunks/bundle-s19NuPaM.js';
import 'react-dom';
import '../hooks/useModal.js';
import '../chunks/bundle-Ca6003_X.js';
import '../chunks/bundle-DrrIZ2Uk.js';
import '../chunks/bundle-91Yg-xh6.js';
import '../chunks/bundle-CCo7ZdMR.js';
import '../chunks/bundle-CPSJLEbT.js';
import './IconButton.js';
import './Button.js';
import './Icon.js';
import '../chunks/bundle-C6Xiexo0.js';
import '../chunks/bundle-ByN2OJfK.js';
import '../chunks/bundle-Dcb1dUnS.js';
import '../chunks/bundle-BSmdL6m-.js';
import '@sendbird/chat';
import '@sendbird/chat/groupChannel';
import '@sendbird/chat/openChannel';
import '../chunks/bundle-DLMIiDGU.js';
import '../chunks/bundle-DGylLBIn.js';

function MobileFeedbackMenu(props) {
    var hideMenu = props.hideMenu, onEditFeedback = props.onEditFeedback, onRemoveFeedback = props.onRemoveFeedback;
    var stringSet = useLocalization().stringSet;
    return (React__default.createElement(BottomSheet, { onBackdropClick: hideMenu },
        React__default.createElement("div", { className: 'sendbird-message__bottomsheet--feedback-options-menu' },
            React__default.createElement("div", { className: 'sendbird-message__bottomsheet--feedback-option', onClick: function () {
                    hideMenu();
                    onEditFeedback();
                } },
                React__default.createElement(Label, { type: LabelTypography.BODY_1, color: LabelColors.ONBACKGROUND_1 }, stringSet.EDIT_COMMENT)),
            React__default.createElement("div", { className: 'sendbird-message__bottomsheet--feedback-option', onClick: function () {
                    hideMenu();
                    onRemoveFeedback();
                } },
                React__default.createElement(Label, { type: LabelTypography.BODY_1, color: LabelColors.ERROR }, stringSet.REMOVE_FEEDBACK)))));
}

export { MobileFeedbackMenu as default };
//# sourceMappingURL=MobileFeedbackMenu.js.map
